export const CLEAR_TOKEN = 'clearToken';
export const SET_TOKEN = 'setToken';
export const SET_SNACKBAR_STATUS = 'setSnackbarStatus';
export const SET_LOADING = 'setLoading';
export const SET_ROLE = 'setRole';
export const SET_BUSINESS = 'setBusiness';
export const SET_LANG = 'setLang';
